import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
// import { UploadService } from '../../upload/upload.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { AuthService } from '../../../core/auth.service';
import { Client } from './../../../models/client';


@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.css']
})
export class EditClientComponent implements OnInit {


  clientForm: FormGroup;
 

  surveyCollection: AngularFirestoreCollection<Client>;
  surveys: Observable<Client[]>;
  // surveyDoc: AngularFirestoreDocument<SurveyItem>;

  doc_id: any;
  formData: any;
  readonly path = 'client';
  clientDocs: Observable<Client[]>;
  calendars: Observable<Client[]>;
  calendarDocs: Observable<Client[]>;
  
  // surveyDoc: AngularFirestoreDocument<Item>;

  getControls(frmGrp: FormGroup, key: string) {
    return (<FormArray>frmGrp.controls[key]).controls;
  }

  
  
  

  constructor(private router: Router, private _fb: FormBuilder, private afs: AngularFirestore, private route: ActivatedRoute, private authService: AuthService) { }
  


 




  getList() {
    
        this.surveyCollection = this.afs.collection('clients', ref => ref.where('client_id', '==', this.doc_id));
    
        this.surveys = this.surveyCollection.snapshotChanges().pipe(take(1)).map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Client;
            data.id = a.payload.doc.id;
            return data;
          });
        });
    
        return this.surveys;
    
      }


      ngOnInit() {
        if (this.authService.loggedInUserRole !== 'Admin') {
          this.router.navigate(['/home'])
        }
       
        this.route.params.subscribe(res => this.doc_id = res.id)
        this.calendarDocs = this.getList();
        this.getList().subscribe((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.formData = doc;
    
          });
          this.formData = this.formData;


          //  console.log(this.formData.questions)
          //   this._form.addControl('questions', this.formData.questions )
    
          this.formData.categories.forEach(p => {
            p.index = this.formData.categories.indexOf(p)
            const control = <FormArray>this.clientForm.controls['categories'];
    
            control.push(this.initCategory());
          });
    
    
    
          this.clientForm.patchValue({
            user_id: this.formData.user_id,
            client_id: this.doc_id,
            client_name: this.formData.client_name,
            createdDate: this.formData.createdDate,
            categories: this.formData.categories,
          });




        })




   
     
  


    var d = new Date();
    var n = 'doc_' + d.getTime();


    this.clientForm = this._fb.group({
      // 'user_id': this.,
      'client_id': this.doc_id,
      'client_name': ['', Validators.required],
      'createdDate': d,
      'categories': this._fb.array([
      ])
    });


      }
    onSubmit() {
     if (this.clientForm.valid) {
     const client_data = this.clientForm.value
      var setDoc = this.afs.collection('clients').doc(this.clientForm.value.client_id).set(client_data);
      alert("Client has been Updated");
      this.router.navigateByUrl('/client/list');
  }
 
  }
  initCategory() {
    return this._fb.group({
      'category': ['', Validators.required],
    });
  }

  addQuestion() {
    const control = <FormArray>this.clientForm.controls['categories'];
    control.push(this.initCategory());
  }
  
  removeCategory(i: number) {
    const control = <FormArray>this.clientForm.controls['categories'];
    control.removeAt(i);

 


  }


 
}


// WEBPACK FOOTER //
// ./src/app/auth/client/edit-client/edit-client.component.ts